import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFocalPoint16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFocalPoint16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.003 3.003a1 1 0 0 0-1 1v1.955a.5.5 0 0 1-1 0V4.003a2 2 0 0 1 2-2h1.954a.5.5 0 0 1 0 1zm8.999 2.955V4.003a1 1 0 0 0-1-1h-1.954a.5.5 0 1 1 0-1h1.954a2 2 0 0 1 2 2v1.955a.5.5 0 1 1-1 0m-1 7.044h-1.954a.5.5 0 0 0 0 1h1.954a2 2 0 0 0 2-2v-1.954a.5.5 0 1 0-1 0v1.954a1 1 0 0 1-1 1m-9-1a1 1 0 0 0 1 1h1.955a.5.5 0 0 1 0 1H4.003a2 2 0 0 1-2-2v-1.954a.5.5 0 0 1 1 0zM8 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFocalPoint16);
